import { Flex, LockedIcon } from '@lokalise/louis';

type IntegrationAppOptionLabelProps = {
    label: string;
    disabled?: boolean;
};
const IntegrationAppOptionLabel = ({ label, disabled }: IntegrationAppOptionLabelProps) => {
    if (!disabled) {
        return <>{label}</>;
    }

    return (
        <Flex gap={1}>
            <LockedIcon />
            {label} (Contact support for add-on)
        </Flex>
    );
};

export default IntegrationAppOptionLabel;
